// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"X_cK","container":"X_x"};